import { gql } from '@apollo/client';

export const SESSION = gql`
  fragment activitySession on ActivitySession {
    createdAt
    id
    updatedAt
    name
    plannedDate
    actualDate
    attendees
    actualDuration
    description
    additionalNotes
    sessionStatus
    plannedAttendees
    sessionBasedAttendeesCount
    sessionBasedActualAttendeesCount
    totalGroupFormAttendees
    flagged
    reasonForFlagging
    numberOfAttendees
    plannedDuration
    service {
      id
      name
    }
    site {
      id
      name
    }
    activityTarget {
      id
      cohort {
        id
        name
      }
      institution {
        id
        name
      }
      plannedDuration
      expectedNumberOfAttendees
    }
    audienceSize {
      id
      name
    }
    sessionAttendees {
      id
      firstName
      lastName
      attendance {
        id
        session {
          id
        }
      }
      primaryInstitution {
        id
        name
      }
      institutions {
        id
        name
      }
    }
    oneOnOneAtendee {
      id
      firstName
      lastName
    }
    attendeeCount
    institutions {
      id
      name
    }
    stakeholderRole {
      id
      name
    }
    attendeeHeadCount {
      id
      sundayNumberOfAttendees
      mondayNumberOfAttendees
      tuesdayNumberOfAttendees
      wednesdayNumberOfAttendees
      thursdayNumberOfAttendees
      fridayNumberOfAttendees
      saturdayNumberOfAttendees
      sundayNumberOfExpectedAttendees
      mondayNumberOfExpectedAttendees
      tuesdayNumberOfExpectedAttendees
      wednesdayNumberOfExpectedAttendees
      thursdayNumberOfExpectedAttendees
      fridayNumberOfExpectedAttendees
      saturdayNumberOfExpectedAttendees
      numberOfExpectedAttendees
      numberOfAttendees
      stakeHolderGroup {
        id
        name
      }
      targetGroup {
        id
        name
      }
    }
  }
`;
